import React, { useContext } from 'react';
import { DashboardContext } from '../../../context/DashboardContext';
import { TrendingUp, TrendingDown} from 'lucide-react';
import { formatCurrency } from '../../../lib/utils';

export default function TopSellingItems() {
  const { dashboardData } = useContext(DashboardContext);
  const { loading, topSellingItems } = dashboardData;

  if (loading) {
    return (
      <div className="bg-white rounded-lg p-5 shadow-sm border border-gray-100">
        <div className="animate-pulse">
          <div className="h-5 bg-gray-200 rounded w-1/3 mb-4"></div>
          <div className="space-y-3">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="h-16 bg-gray-100 rounded-lg"></div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (!topSellingItems || topSellingItems.length === 0) {
    return (
      <div className="bg-white rounded-lg p-5 shadow-sm border border-gray-100 text-center text-gray-500">
        No top-selling items found for this period.
      </div>
    );
  }

  const topItems = topSellingItems.slice(0, 5);

  const getCategoryColor = (category) => {
    const colors = {
      Appetizers: 'bg-teal-100 text-teal-700',
      'Main Course': 'bg-blue-100 text-blue-700',
      Desserts: 'bg-purple-100 text-purple-700',
      Breads: 'bg-orange-100 text-orange-700',
      Beverages: 'bg-cyan-100 text-cyan-700',
      'New Item': 'bg-emerald-100 text-emerald-700',
      General: 'bg-gray-100 text-gray-700',
    };
    return colors[category] || 'bg-gray-100 text-gray-700';
  };


  return (
    <div className="bg-white rounded-lg p-5 shadow-sm border border-gray-100">
      <h2 className="text-lg font-bold text-gray-900 mb-4">Trending Items</h2>
      <div className="space-y-3">
        {topItems.map((item, index) => (
          <div
            key={index}
            className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors duration-150"
          >
            <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-gray-100 rounded text-sm font-bold text-gray-700">
              #{index + 1}
            </div>

            <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-gradient-to-br from-orange-400 to-red-500 flex items-center justify-center">
              <span className="text-white text-xs font-bold">
                {item.name.substring(0, 2).toUpperCase()}
              </span>
            </div>

            <div className="flex-1 min-w-0">
              <h3 className="font-semibold text-gray-900 text-sm truncate mb-0.5">
                {item.name}
              </h3>
              <div className="flex items-center gap-2">
                <span className="text-xs font-semibold text-gray-900">
                  {formatCurrency(item.price)}
                </span>
                <span
                  className={`text-xs font-medium px-2 py-0.5 rounded ${getCategoryColor(item.category)}`}
                >
                  {item.category}
                </span>
              </div>
            </div>

            <div className="flex-shrink-0 text-right">
              <div className="flex items-center justify-end gap-1 mb-1">
               {item.trend === 'Decreased' ? (
                  <TrendingDown className="w-4 h-4 text-red-500" />
                    ) : (
                  <TrendingUp className="w-4 h-4 text-green-500" />
              )}
                <span className="text-2xl font-bold text-gray-900">
                  {item.quantity}
                </span>
              </div>
              <p className="text-xs text-gray-500">
                Sales ({Math.abs(item.salesChangePercentage || 0).toFixed(0)}%)
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}